import { useDispatch, useSelector } from 'react-redux';
import {
    getContactUsMessagesIsDeleting,
    getContactUsMessagesDeleteError,
} from '@selectors/contactUsMessages';
import usePrevious from 'lib/src/hooks/usePrevious';
import { deleteContactUsMessage } from '@actions/contactUsMessages';

export default function useDeleteContactUsMessage(id: number): UseDeleteMessageReturn {
    const dispatch = useDispatch();

    const handleSubmit = () => {
        dispatch(deleteContactUsMessage(id));
    };

    const isDeleting = useSelector(getContactUsMessagesIsDeleting);
    const wasDeleting = usePrevious(isDeleting);
    const deleteError = useSelector(getContactUsMessagesDeleteError);

    return {
        handleSubmit,
        isDeleting,
        wasDeleting,
        deleteError,
    };
}

interface UseDeleteMessageReturn {
    handleSubmit: () => void;
    isDeleting: boolean;
    wasDeleting: boolean;
    deleteError: string | null;
}
